import React from 'react';
function SignalCellular4Bar() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M2 22h20V2z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default SignalCellular4Bar;
